import { Container, Grid } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import ENV from "libs/configs/env";

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.secondary.main,
    color: "#ffffff",
    // minHeight: 64,
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 16,
    paddingBottom: 16,
  },
  container: { alignItems: "center", justifyContent: "center" },
  copyright: {
    textAlign: "center",
    "@media (min-width:960px)": {
      textAlign: "left",
    },
  },
}));

export default function Footer() {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <Container>
        <Grid container className={classes.container}>
          <Grid item xs={10} className={classes.copyright}>
            <span>
              &copy; Copyright 2021 BOI (Thailand) Co.,Ltd. (
              {ENV.getConfig().version})
            </span>
          </Grid>
          <Grid item>
            <IconButton color="inherit">
              <FacebookIcon />
            </IconButton>
            <IconButton color="inherit">
              <TwitterIcon />
            </IconButton>
            <IconButton color="inherit">
              <InstagramIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
}
